/**
 * GA4 is loaded from public/index.html (gtag).
 * Use trackPageView for SPA route changes; use trackEvent for custom actions.
 */

export function trackPageView() {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    const { pathname, search, href } = window.location;
    window.gtag('event', 'page_view', {
        page_path: pathname + search,
        page_title: document.title,
        page_location: href,
    });
}

export function trackEvent(eventName, params = {}) {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    window.gtag('event', eventName, params);
}
